import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { editActivity } from '@capital-access/common/actions';
import { LocalizationScopeDirective, LocalizePipe } from '@capital-access/common/localization';
import { NOTIFICATIONS_LOCALIZATION_SCOPE } from '../../constants/notifications-drawer.constants';
import {
  ActivityNotificationBody,
  NotificationDto,
  parseNotificationBody
} from '../../models/notifications-grouped.model';
import { selectDeletingNotificationIds } from '../../+store/notifications-drawer.selectors';

@Component({
  selector: 'ca-activity-notification-item',
  templateUrl: './activity-notification-item.component.html',
  styleUrls: ['./activity-notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DatePipe, LocalizationScopeDirective, LocalizePipe]
})
export class ActivityNotificationItemComponent {
  notification = input.required<NotificationDto>();
  markAsRead = output<number>();
  delete = output<number>();

  readonly localizationScope = NOTIFICATIONS_LOCALIZATION_SCOPE;
  readonly body = computed(() => parseNotificationBody<ActivityNotificationBody>(this.notification().body));

  private store = inject(Store);
  private deletingIds = toSignal(this.store.select(selectDeletingNotificationIds), { initialValue: [] as number[] });
  readonly deleting = computed(() => this.deletingIds().includes(this.notification().notificationId));

  onOpen(): void {
    const body = this.body();
    if (body?.sourceEntityId) {
      this.store.dispatch(
        editActivity({ activityId: body.sourceEntityId, addBackButton: true, returnToPreviousDrawer: true })
      );
    }
    if (!this.notification().read) {
      this.markAsRead.emit(this.notification().notificationId);
    }
  }

  onDelete(): void {
    if (this.deleting()) return;
    this.delete.emit(this.notification().notificationId);
  }

  onMarkAsRead(): void {
    this.markAsRead.emit(this.notification().notificationId);
  }
}
